<template>
  <div class="lg:flex xl:w-full mt-10 justify-center">
    <div class="flex lg:w-1/3 mb-6">
      <img
        class="flex mb-6 mr-3 flex-shrink-0"
        src="/images/benefits/shirt-drop.svg"
        alt=""
        aria-hidden="true"
        role="presentation"
        width="64"
        height="64"
      />
      <div>
        <div class="text-lg font-bold text-blue-80 mb-1">
          {{ $t('views.checkout.benefits.headline_1') }}
        </div>
        <span class="text-gray-70">{{ $t('views.checkout.benefits.text_1') }}</span>
      </div>
    </div>

    <div class="flex lg:w-1/3 mb-6">
      <img
        class="flex mb-6 mr-3"
        src="/images/benefits/stopwatch.svg"
        alt=""
        aria-hidden="true"
        role="presentation"
        width="64"
        height="64"
      />
      <div>
        <div class="text-lg font-bold text-blue-80 mb-1">
          {{ $t('views.checkout.benefits.headline_2') }}
        </div>
        <span class="text-gray-70">{{ $t('views.checkout.benefits.text_2') }}</span>
      </div>
    </div>

    <div class="flex lg:w-1/3 mb-6">
      <img
        class="flex mb-6 mr-3 flex-shrink-0"
        src="/images/benefits/speech-bubbles.svg"
        alt=""
        aria-hidden="true"
        role="presentation"
        width="64"
        height="64"
      />
      <div>
        <div class="text-lg font-bold text-blue-80 mb-1">
          {{ $t('views.checkout.benefits.headline_3') }}
        </div>
        <span class="text-gray-70">{{ $t('views.checkout.benefits.text_3') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BenefitsFooter'
  }
</script>
